import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const FILE_URL = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;

const TOKEN_KEY = "mg_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data;
};

export const fetchMedia = async (section) => {
  const { data } = await axios.get(`${API}/media`, { params: section ? { section } : {} });
  return data;
};

// Chunked upload for large files (videos up to 2GB). Uploads up to 3 chunks in parallel.
// onProgress(percent 0-100).
export const chunkedUpload = async (file, section, caption, onProgress) => {
  const initRes = await axios.post(
    `${API}/media/upload/init`,
    { filename: file.name, section, caption, content_type: file.type || "application/octet-stream", total_size: file.size },
    { headers: authHeader() }
  );
  const { upload_id, chunk_size } = initRes.data;
  const total = Math.max(1, Math.ceil(file.size / chunk_size));
  const CONCURRENCY = Math.min(3, total);
  let done = 0;

  const uploadChunk = async (i) => {
    const blob = file.slice(i * chunk_size, (i + 1) * chunk_size);
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", i);
    fd.append("chunk", blob, "chunk");
    let lastErr;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        await axios.post(`${API}/media/upload/chunk`, fd, { headers: { ...authHeader() } });
        lastErr = null;
        break;
      } catch (e) {
        lastErr = e;
        await new Promise((r) => setTimeout(r, 800 * (attempt + 1)));
      }
    }
    if (lastErr) throw lastErr;
    done += 1;
    if (onProgress) onProgress(Math.round((done / total) * 100));
  };

  let next = 0;
  const worker = async () => {
    while (true) {
      const i = next++;
      if (i >= total) break;
      await uploadChunk(i);
    }
  };
  await Promise.all(Array.from({ length: CONCURRENCY }, () => worker()));

  const doneForm = new FormData();
  doneForm.append("upload_id", upload_id);
  const { data } = await axios.post(`${API}/media/upload/complete`, doneForm, { headers: authHeader() });
  return data;
};

// "Remember me" — store admin credentials in the browser (base64-obfuscated in localStorage).
const CREDS_KEY = "mg_admin_creds";
export const saveCreds = (email, password) => {
  try { localStorage.setItem(CREDS_KEY, btoa(JSON.stringify({ email, password }))); } catch { /* ignore */ }
};
export const loadCreds = () => {
  try {
    const raw = localStorage.getItem(CREDS_KEY);
    return raw ? JSON.parse(atob(raw)) : null;
  } catch { return null; }
};
export const clearCreds = () => localStorage.removeItem(CREDS_KEY);
